// used for image and placeholder shapes wrapping
export const getWrapStyle = (floatValue: string): any => {
  const isFloating = floatValue === 'left' || floatValue === 'right';
  const isCentered = floatValue === 'center';
  const isInline = floatValue === 'inline';
  const isBreak = floatValue === 'break';

  if (isInline) {
    return {
      float: undefined,
      margin: '0 8px 0 0',
      display: 'inline-block',
      clear: 'none',
      maxWidth: undefined,
      verticalAlign: 'baseline',
      shapeOutside: undefined,
      WebkitShapeOutside: undefined,
      shapeMargin: undefined
    };
  }

  if (isBreak) {
    return {
      float: undefined,
      margin: '12px 0 14px 0',
      display: 'block',
      clear: 'both',
      maxWidth: undefined,
      verticalAlign: undefined,
      shapeOutside: undefined,
      WebkitShapeOutside: undefined,
      shapeMargin: undefined
    };
  }

  if (isCentered) {
    return {
      float: undefined,
      margin: '10px auto 14px auto',
      display: 'block',
      clear: 'both',
      maxWidth: undefined,
      verticalAlign: undefined,
      shapeOutside: undefined,
      WebkitShapeOutside: undefined,
      shapeMargin: undefined
    };
  }

  if (!isFloating) {
    return {
      float: undefined,
      margin: '4px 10px 8px 0',
      display: 'inline-block',
      clear: 'none',
      maxWidth: undefined,
      verticalAlign: undefined,
      shapeOutside: undefined,
      WebkitShapeOutside: undefined,
      shapeMargin: undefined
    };
  }

  const isLeft = floatValue === 'left';

  return {
    float: floatValue,
    margin: isLeft ? '6px 14px 10px 0' : '6px 0 10px 14px',
    display: 'block',
    clear: 'none',
    maxWidth: undefined,
    verticalAlign: undefined,
    shapeOutside: 'inset(0 round 6px)',
    WebkitShapeOutside: 'inset(0 round 6px)',
    shapeMargin: '10px'
  };
};
